import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { IAdvancePaymentListItem } from '../../shared/models/reception/advance-payment-list-item';

export const advancePaymentApi = createApi({
  reducerPath: 'advancePaymentApi',
  baseQuery,
  endpoints: (builder) => ({
    advancePaymentList: builder.query<IPagedResult<IAdvancePaymentListItem>, string>({
      query: (params) => ({
        url: `/api/prepaidinvoices?${params}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyAdvancePaymentListQuery } = advancePaymentApi;
